// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2BxWH","notes":"Notes_notes__1ZQB7","note":"Notes_note__1OtfF","markdown":"Notes_markdown__3CUCo"};